export default "__VITE_ASSET__C4Ya0bQA__"